import { ComplaintType } from 'models/complaint-type.model';
import { ComplaintStatus } from 'store/modules/complaints/types';
import * as yup from 'yup';

export const complaintSchema = yup.object().shape({
    title: yup.string()
        .required('Título é obrigatório.')
        .min(2, 'Mínimo de dois caracteres.')
        .max(20, 'Máximo de 20 caracteres.'),
    type: yup.number()
        .typeError('Tipo de manifestação é obrigatório')
        .oneOf(
            Object.values(ComplaintType).map(x => +x).filter(x => !isNaN(x)),
            'Tipo de manifestação inválida'
        ),
    description: yup.string()
        .required('Descrição é obrigatória.')
        .min(2, 'Deve conter no mínimo dois caracteres.')
        .max(250, 'Deve conter no máximo 250 caracteres.'),
    photo: yup.mixed().required('Imagem é obrigatória.')
});

export type ComplaintFormData = {
    title: string;
    type: ComplaintType;
    description: string;
    photo: File;
}

export const complaintStatusMap: Record<ComplaintStatus, number> = {
    'Não atendida': 1,
    'Respondida pela prefeitura': 2,
    'Respondida pelo usuário': 3,
    'Encerrada': 4,
}